import React, { useState, useImperativeHandle, useEffect, useRef } from 'react';
function Select( { label, defaultValue, gridWidth, icon , options , onChange , visible } , ref ) {
    const containerClass = [
        'textfield',
        gridWidth === 'HALF' ? 'half' : 'full',
        visible === false ? 'hidden' : ''
    ].join(' ').trim();

    const [ isOpen, setIsOpen ] = useState( false );
    const selectRef = useRef( null );

    let initialSelected = options[0];
    let customColorAtStart = '#000000';
    if ( defaultValue != null ) {
        for ( let i = 0; i < options.length; i++ ) {
            if ( options[i].swatch != null ) {
                if ( options[i].swatch == defaultValue ) {
                    initialSelected = options[i];
                    customColorAtStart = options[i].swatch;
                    break;
                }
            } else {
                if ( options[i].value === defaultValue ) {
                    initialSelected = options[i];
                    break;
                }
            }
            
        }
    }

    const [ customColor, setCustomColor ] = useState( customColorAtStart );
    const [ selected, setSelected ] = useState( initialSelected );
    
    useEffect(() => {
        const handleClickOutside = ( event ) => {
            const elementClicked =  event.target;
            if ( selectRef?.current != null ) {
                if ( !selectRef.current.contains( elementClicked ) ) {
                    setIsOpen( false );
                }
            }
        };

        document.addEventListener( 'click', handleClickOutside );
        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    } , [])

    useImperativeHandle(ref, () => ({
        getValue: () => selected,
        setValue: ( val ) => setSelected( val ),
    }));

    const toggleDropdown = () => setIsOpen( !isOpen );
    const handleSelect = (option) => {
        setSelected( option );
        if ( option.value === "Custom" ) {
            option.swatch = customColor;
        }

        if ( typeof onChange === 'function' ) {
            onChange( option );
        }
        setIsOpen(false);
    };

    // TODO: DEBOUNCE THIS 
    const handleCustomColorChange = ( newColor ) => {
        setCustomColor( newColor );
        selected.swatch = newColor;

        let option = null;
        for ( let i = 0; i < options.length; i++ ) {
            if ( options[i].value === "Custom" ) {
                options[i].swatch = newColor;
                option = options[i];
                break;
            }
        }

        if ( typeof onChange === 'function' && option != null ) {
            onChange( option );
        }
    }

    return (
        <div className={containerClass} ref={selectRef}>
            {label != null && (
                <label className="textfield-label">
                    {icon != null && (
                        <span className="textfield-icon">
                            <div dangerouslySetInnerHTML={{ __html: icon }} />
                        </span>
                    )}
                    {label}
                </label>
            )}

            <div className="custom-select-wrapper">
                <div className="custom-select">
                    <div className="select-display" onClick={toggleDropdown}>
                        { selected?.icon != null ? (
                            <span dangerouslySetInnerHTML={{ __html: selected.icon }}></span>
                        ) : selected?.swatch != null ? (
                            <div className="swatch" style={{ backgroundColor: selected.swatch }}></div>
                        ) : null }
                        <span style={ { "fontFamily": selected?.linked_font_data?.font_name || 'inherit' } } className="select-value">{selected?.value}</span>
                        <span className={`select-arrow ${isOpen ? 'rotated' : ''}`}>
                            <svg width="11" height="6" viewBox="0 0 11 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M5.39998 6C5.20642 6 5.01289 5.92797 4.86532 5.78422L0.221553 1.25832C-0.073851 0.970413 -0.073851 0.503627 0.221553 0.21584C0.516838 -0.0719467 0.995689 -0.0719467 1.29112 0.21584L5.39998 4.22061L9.50887 0.21598C9.80427 -0.0718069 10.2831 -0.0718069 10.5783 0.21598C10.8739 0.503767 10.8739 0.970553 10.5783 1.25846L5.93464 5.78436C5.787 5.92813 5.59347 6 5.39998 6Z" fill="#ffffff" />
                            </svg>
                        </span>
                    </div>

                    <ul className={`select-options ${isOpen ? 'open' : 'closed'}`}>
                        {options.map((option) => (
                            <li
                                key={option.id}
                                className={option.id === selected.id ? 'selected' : ''}
                                onClick={() => handleSelect(option)}
                            >
                                { option?.icon != null ? (
                                    <span dangerouslySetInnerHTML={{ __html: option.icon }}></span>
                                ) : option?.swatch != null ? (
                                    <div className="swatch" style={{ backgroundColor: option.swatch }}></div>
                                ) : null}

                                
                                <span style={ { "fontFamily": option?.linked_font_data?.font_name || 'inherit' } } className="option-value">{option.value}</span>
                            </li>
                        ))}
                    </ul>
                </div>

                { selected.value === "Custom" && label == "Color" &&
                    <input 
                        type="color"
                        id="custom-color"
                        name="custom-color"
                        value={customColor}
                        onChange={(e) => handleCustomColorChange( e.target.value ) } 
                    />
                }
            </div>
        </div>
    );
}

export default React.forwardRef( Select );